import { SWRConfiguration } from 'swr';

export const SWR_GLOBAL_CONFIG = {
  // NOTE: 以下3つのoptionにより、apiの2回目以降の自動fetchを無効化する
  // refs: https://swr.vercel.app/ja/docs/revalidation#disable-automatic-revalidations
  revalidateIfStale: false,
  revalidateOnFocus: false,
  revalidateOnReconnect: false,
} satisfies SWRConfiguration;
